import type { LabelColorPreset } from './labels-types';

export const LABEL_COLOR_PRESETS: LabelColorPreset[] = [
  { color: '#1976D2', backgroundColor: '#B0D2FF' }, // Blue
  { color: '#388E3C', backgroundColor: '#65CF7E' }, // Green
  { color: '#E53935', backgroundColor: '#FF627D' }, // Red
  { color: '#8E24AA', backgroundColor: '#D6DBE7' }, // Purple
  { color: '#1565C0', backgroundColor: '#3788E6' }, // Indigo
  { color: '#6A1B9A', backgroundColor: '#9C80FF' }, // Deep Purple
  { color: '#F9A825', backgroundColor: '#F4BA61' }, // Amber/Gold
];

export const DEFAULT_LABEL_COLOR = LABEL_COLOR_PRESETS[0];
